import React, { useEffect, useRef } from 'react'
import { useTable, usePagination, useSortBy } from "react-table"

function Table({ columns, data, pageSize: externalPageSize = 20, setPageSize: setExternalPageSize, titulo = '' }) {
    const props = useTable(
        {
            columns,
            data,
            initialState: { pageSize: externalPageSize }
        },
        useSortBy,
        usePagination
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize: internalPageSize }
    } = props;

    const prevExternalPageSize = useRef(externalPageSize);

    // Sincronizar pageSize externo para interno
    useEffect(() => {
        if (prevExternalPageSize.current !== externalPageSize && internalPageSize !== externalPageSize) {
            setPageSize(externalPageSize);
            prevExternalPageSize.current = externalPageSize;
        }
    }, [externalPageSize, internalPageSize, setPageSize]);

    return (
        <>
            <div className="table-full-width mt-3 mb-3">
                <div className="table-responsive">
                    <table {...getTableProps()} className="table align-middle mt-1 table-striped table-hover">
                        {titulo && (
                            <thead>
                                <tr>
                                    <th colSpan={columns.length} className='bg-primary text-white rounded-top'>{titulo}</th>
                                </tr>
                            </thead>
                        )}
                        <thead>
                            {headerGroups.map((headerGroup, groupIndex) => (
                                <tr key={groupIndex} {...headerGroup.getHeaderGroupProps()} className='border border-white text-nowrap'>
                                    {headerGroup.headers.map((column, colIndex) => {
                                        // Obter a coluna original do array columns para acessar accessor/id diretamente
                                        const originalColumn = columns[colIndex];
                                        const originalAccessor = originalColumn?.accessor;
                                        const originalId = originalColumn?.id;
                                        
                                        // Obter accessor como string
                                        const accessorStr = typeof originalAccessor === 'string' ? originalAccessor : '';
                                        const columnId = column.id || originalId || '';
                                        
                                        // Mapear por id/accessor para labels estáticos
                                        const getLabel = () => {
                                            // Verificar por id primeiro (da coluna processada ou original)
                                            if (columnId === 'foto' || originalId === 'foto') return '';
                                            if (columnId === 'pratica' || originalId === 'pratica') return 'Prática';
                                            if (columnId === 'notas' || originalId === 'notas') return 'Histórico';
                                            if (columnId === 'certificado' || originalId === 'certificado') return 'Certificado';
                                            
                                            // Verificar por accessor
                                            if (accessorStr === 'nome_completo') return 'Nome';
                                            if (accessorStr === 'status') return 'Status';
                                            if (accessorStr === 'porcentagem_concluida') return 'Frequência de Aulas';
                                            if (accessorStr === 'email') return '';
                                            
                                            return '';
                                        };
                                        
                                        const getAlignment = () => {
                                            if (accessorStr === 'status' || columnId === 'status' || originalId === 'status' || 
                                                columnId === 'pratica' || originalId === 'pratica' || 
                                                columnId === 'certificado' || originalId === 'certificado') {
                                                return 'text-center';
                                            }
                                            return '';
                                        };
                                        
                                        // Sempre usar label estático baseado no id/accessor
                                        const displayLabel = getLabel();
                                        
                                        // Sempre renderizar o header, mesmo se a coluna estiver oculta
                                        const isColumnHidden = column.visible === false || originalColumn?.visible === false;
                                        
                                        return (
                                            <th 
                                                key={columnId || accessorStr || `header-${colIndex}`}
                                                {...column.getHeaderProps(column.canSort ? column.getSortByToggleProps() : {})}
                                                className={`text-uppercase text-black-50 fw-bold fs-8 bg-muted ${getAlignment()} ${column.canSort ? 'cursor-pointer' : ''} ${isColumnHidden ? 'd-none' : ''}`}
                                            >
                                                {displayLabel}
                                                {column.canSort && (
                                                    <span className="ms-2">
                                                        {column.isSorted ? (
                                                            column.isSortedDesc ? (
                                                                <i className="bi bi-sort-down"></i>
                                                            ) : (
                                                                <i className="bi bi-sort-up"></i>
                                                            )
                                                        ) : (
                                                            <i className="bi bi-arrow-down-up text-muted"></i>
                                                        )}
                                                    </span>
                                                )}
                                            </th>
                                        );
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr className='text-nowrap' {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return (
                                                <td className={`${cell.column.visible === false ? "d-none" : ""}`} {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}

                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan={columns.length} className='bg-primary text-white rounded-bottom'>
                                    <div className="table-footer d-flex justify-content-between align-items-center">
                                        <span>Exibindo {Math.min(pageIndex * internalPageSize + page.length, rows.length)} de {rows.length} registros</span>
                                        <div>
                                            <span>Página {pageIndex + 1} de {pageOptions.length}</span>
                                            <button className="btn btn-primary btn-sm ms-2 text-white" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                <i className="bi bi-caret-left"></i>
                                            </button>
                                            <button className="btn btn-primary btn-sm ms-1 text-white" onClick={() => nextPage()} disabled={!canNextPage}>
                                                <i className="bi bi-caret-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    )

}
export default Table;